<!-- src/components/sections/NewsletterCTA.svelte -->
<script>
  import Button from '../common/Button.svelte';
</script>

<section class="newsletter" aria-labelledby="newsletter-heading">
  <div class="container">
    <h2 id="newsletter-heading">Prefer to start free?</h2>
    <p>
      Down to Earth Guides is my plain-English series on making AI actually work —
      no jargon, no hype. You'll also get the evergreen explainer on why AI pilots
      stall and how the winners avoid it.
    </p>
    <Button href="/join" variant="outline" size="medium">Get the free series</Button>
  </div>
</section>

<style>
  .newsletter {
    background: var(--color-card-bg);
    padding: 3.5rem 0;
    border-top: 1px solid var(--color-card-hover);
  }

  .container {
    max-width: 720px;
    margin: 0 auto;
    padding: 0 2rem;
    text-align: center;
  }

  h2 {
    font-size: 1.75rem;
    color: var(--color-text);
    margin: 0 0 0.75rem;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: var(--color-text-muted);
    margin: 0 0 1.75rem;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.4rem;
    }

    p {
      font-size: 1rem;
    }
  }
</style>
